import { ProposalAdjustmentRequest } from '../../../domain'

export const hasChanges = (adjustment: ProposalAdjustmentRequest) =>
  Boolean(adjustment.coverStart || adjustment.changes.length || adjustment.applyRating)
